import objectionTrackActions from "./actions";

const initialState = {

    objectionTrack:[],
    answerKey : [],
    rollNo : [],
    objectionCourses : [],
    objectionDetails : [],

 };

const objectionTrackerReducer = (state = initialState, action) => {
  switch (action.type) {
    

    case objectionTrackActions.SET_OBJECTION_TRACKER:
        return {
          ...state,
          objectionTrack: action.payload,
        };


        case objectionTrackActions.SET_ROLL_NO:
          return {
            ...state,
            rollNo: action.payload,
          };
     

        
    case objectionTrackActions.SET_ANSWER_KEY:
        return {
          ...state,
          answerKey: action.payload,
        };

        case objectionTrackActions.SET_OBJECTION_COURSES:
          return {
            ...state,
            objectionCourses: action.payload,
          };


          case objectionTrackActions.SET_CANDIDATE_OBJECTION_DETAILS:
            return {
              ...state,
              objectionDetails: action.payload,
            };
         
              
            
    default:
      return state;
  }
};

export default objectionTrackerReducer;
